import { createAsyncThunk } from '@reduxjs/toolkit';
import { ServiceCart } from '@services/ServiceCart';
import { removeApiDto } from './api.dto';

export const fetchDeleteProductFromBasket = createAsyncThunk('basket/fetchDeleteProductFromBasket', async (query: removeApiDto) => {
  const { productId, regionId } = query;
  return await ServiceCart.remove(productId, regionId);
});
